export default __webpack_public_path__ + "static/media/image37.546240ae.jpg";